/*
 * Cocobelle wishlist — stores saved product handles in localStorage so it works
 * for guests and logged-in customers without an app or login. Saved items stay
 * on the device until the customer removes them (not just for the session).
 *
 * Markup hooks:
 *   [data-cb-wishlist-toggle="<handle>"]  heart button (product page)
 *   [data-cb-wishlist-count]              header count bubble
 * Other scripts can use window.CBWishlist and listen for "cb:wishlist:change".
 */
(function () {
  if (window.CBWishlist) return;

  var KEY = 'cb:wishlist:v1';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    notify(list);
  }

  function notify(list) {
    render(list);
    document.dispatchEvent(new CustomEvent('cb:wishlist:change', { detail: { items: list } }));
  }

  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }

  function add(handle) {
    var list = read();
    if (list.some(function (i) { return i.handle === handle; })) return;
    list.unshift({ handle: handle, added: Date.now() });
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }

  function toggle(handle) {
    if (has(handle)) { remove(handle); return false; }
    add(handle);
    return true;
  }

  function render(list) {
    list = list || read();
    var saved = {};
    list.forEach(function (i) { saved[i.handle] = true; });

    document.querySelectorAll('[data-cb-wishlist-count]').forEach(function (el) {
      el.textContent = list.length ? (list.length < 100 ? list.length : '99+') : '';
      el.hidden = !list.length;
    });

    document.querySelectorAll('[data-cb-wishlist-toggle]').forEach(function (btn) {
      var isSaved = !!saved[btn.getAttribute('data-cb-wishlist-toggle')];
      btn.classList.toggle('is-saved', isSaved);
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      var label = btn.querySelector('[data-cb-wishlist-label]');
      if (label) label.textContent = isSaved ? (btn.getAttribute('data-label-saved') || 'Saved') : (btn.getAttribute('data-label-save') || 'Save');
    });
  }

  // Capture phase so a heart on a product card never reaches the card's link or
  // any card-level click handlers (it must not open the product page).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cb-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-cb-wishlist-toggle'));
  }, true);

  // Keep other open tabs in sync.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) notify(read());
  });

  // Cards added later (collection filters/sorting, product recommendations,
  // carousels) need their hearts set to the saved state.
  function watchNewCards() {
    var queued = false;
    new MutationObserver(function (mutations) {
      if (queued) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-cb-wishlist-toggle]') || n.querySelector('[data-cb-wishlist-toggle]'))) {
            queued = true;
            requestAnimationFrame(function () { queued = false; render(); });
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.CBWishlist = { items: read, has: has, add: add, remove: remove, toggle: toggle, render: render };

  function init() { render(); watchNewCards(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
